<script lang="ts">
  import type { GameraTeamReference, NflDrive } from '@statmuse/core/gamera'
  import Drive from './drive.svelte'
  import { drives } from './stores'

  export let awayTeam: GameraTeamReference | undefined
  export let homeTeam: GameraTeamReference | undefined
  export let live = false

  let allDrives: NflDrive[]

  $: {
    allDrives = live ? [...$drives].reverse() : [...$drives]
  }
</script>

{#each allDrives as drive (drive.driveSequence)}
  <Drive {drive} {live} {awayTeam} {homeTeam} />
{/each}
